import * as React from 'react';
import styled from 'styled-components';
import { color, space, fontSize, breakpoint } from '@core-ds/primitives';
import { Avatar } from 'core-components';
import Dropdown from './dropdown';
import MenuButton from './menu_button';
import { withBreakpoints, BreakpointsContext } from 'core-components';

const Container = styled.div`
   text-align: left;
`;

const Icon = withBreakpoints(styled(Avatar)`
   cursor: pointer;
   width: ${props => (props.breakpoints.isDesktop() ? '32px' : '24px')};
   height: ${props => (props.breakpoints.isDesktop() ? '32px' : '24px')};
`);

const Section = styled.div`
   background: white;
   text-align: left;
   border-bottom: 1px solid ${color.gray2};
   padding: ${props => props.padding || space[2] + ' 0'};
`;

const Title = styled.h3`
   font-size: ${fontSize[2]};
   color: ${color.black};
   margin: 0;
`;

const Subtitle = styled.h3`
   font-size: ${fontSize[2]};
   font-weight: normal;
   color: ${color.gray6};
   margin-top: 8px;
`;

const UserDropdown = ({
   username,
   uniqueUsername,
   profileUrl,
   notificationsUrl,
   avatar,
   team,
   isAdmin,
   notifications,
}) => {
   const breakpoints = React.useContext(BreakpointsContext);
   const unreadNotifications = notifications.getUnreadNotifications();

   return (
      <Dropdown
         icon={<Icon id="profileMenuToggle" src={avatar} aria-label="profile" focusable="false" />}
         hasBadge={breakpoints.isMobileTablet() && notifications.getUnreadCount()}
      >
         <Container>
            <Section padding={space[4]}>
               <Title>{username}</Title>
               {uniqueUsername && <Subtitle>&#x40;{uniqueUsername}</Subtitle>}
            </Section>
            <Section id="profileMenu">
               <MenuButton
                  url={notificationsUrl}
                  text={_js('Notifications')}
                  badge={notifications.getUnreadCount()}
               />
               <MenuButton id="myAccount" url={profileUrl} text={_js('View Profile')} />
               {team && (
                  <MenuButton
                     url={team.teamLink}
                     text={team.teamCount > 1 ? _js('My Teams') : _js('My Team')}
                  />
               )}
               {isAdmin && <MenuButton url={'/Manage'} text={_js('Manage')} />}
            </Section>
            <Section>
               <MenuButton
                  id="navLogout"
                  url={shared_constants.GuideURI('TAG_LOGOUT')}
                  text={_js('Log Out')}
               />
            </Section>
         </Container>
      </Dropdown>
   );
};

export default UserDropdown;
